import { render } from "./pop-up.vue?vue&type=template&id=b79496ca&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b79496ca"

export default script